import $foreign from "./foreign.cjs";
var init = $foreign.init;
var update = $foreign.update;
export { init, update };
